<div>
  <div class="full-width flex justify-between p-3 bg-gray-400 items-center">
    <app-main-button (click)="navigateBack()">Zurück</app-main-button>
  </div>

  <div class="p-10">
    <ng-container *ngIf="provisionRequest; else loading">
      <h2 class="text-3xl text-primary pb-12">
        {{ provisionRequest.bezeichnung }}
        <span *ngIf="provisionRequest.spindstandort"
          >({{ provisionRequest.spindstandort }})</span
        >
      </h2>

      <ng-container *ngIf="provisionRequest.beendetAm">
        <nz-alert
          nzType="warning"
          nzShowIcon
          nzMessage="Diese Versorgungsanfrage ist beendet."
          class="flex pb-5"
        ></nz-alert>
      </ng-container>
      <div class="flex pb-5">
        <span
          nz-tooltip
          nzTooltipTitle="Verwenden Sie einfach den Handscanner, um eine Kleidungsstück
                oder eine Person zu scannen."
        >
          <nz-alert
            nzType="warning"
            nzShowIcon=""
            nzMessage="Scanfunktion aktiv"
          >
          </nz-alert>
        </span>
      </div>

      <form [formGroup]="provisionRequestForm">
        <div class="pb-5 grid grid-cols-12 gap-5">
          <app-form-input
            label="Modul"
            attribute="modulBezeichnung"
            [readOnly]="true"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          ></app-form-input>
          <app-form-input
            label="Zeitraum"
            attribute="zeitraum"
            [readOnly]="true"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          ></app-form-input>
          <app-form-input
            label="Ersteller"
            attribute="ersteller"
            [readOnly]="true"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          ></app-form-input>
          <app-form-input
            label="Erstellt am"
            attribute="datum"
            [readOnly]="true"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          ></app-form-input>
          <app-form-input
            label="Kleidungsart"
            attribute="kleidungsart"
            [readOnly]="true"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          ></app-form-input>
          <app-form-input
            label="Spindart"
            attribute="spindart"
            [readOnly]="true"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          ></app-form-input>
          <app-form-textarea
            label="Bemerkung"
            [maxCharacterCount]="300"
            attribute="bemerkung"
            [readOnly]="true"
            class="sm: col-span-12 md:col-span-12 xl:col-span-6"
          ></app-form-textarea>
        </div>
      </form>

      <div class="flex items-center justify-between pb-5">
        <div class="flex justify-start space-x-3">
          <h2 class="text-2xl text-primary pb-3">Teilnehmer:innen</h2>
          <nz-input-group
            class="w-1/2 pb-5"
            nzSearch
            [nzAddOnAfter]="suffixIconButton"
            ><input
              #searchInput
              [(ngModel)]="searchValue"
              type="text"
              nz-input
              placeholder="Personensuche (Scannen oder Tippen)"
              (input)="onSearchInput()"
            /> </nz-input-group
          ><ng-template #suffixIconButton>
            <button (click)="onSearch()" nz-button nzType="primary" nzSearch>
              <span nz-icon nzType="search"></span>
            </button>
          </ng-template>
        </div>
        <ng-container
          *ngIf="
            !provisionRequest.bezeichnung.includes('Kleidertausch');
            else changeClothing
          "
        >
          <div class="flex justify-end space-x-3">
            <ng-container *ngIf="provisionRequest.kleidungsart === '2'">
              <app-main-button (click)="printTable()">
                Druckansicht
              </app-main-button>
            </ng-container>
            <a
              nz-dropdown
              [nzDropdownMenu]="menu"
              [ngClass]="{ 'readonly-select': !activeState() }"
            >
              <app-main-button [disabled]="!activeState()">
                Tabellenaktionen <span nz-icon nzType="down"></span>
              </app-main-button>
            </a>
            <nz-dropdown-menu #menu="nzDropdownMenu">
              <ul nz-menu nzSelectable>
                <li nz-menu-item (click)="acceptLockers()">
                  Ausgewählte Spinde ausgeben
                </li>
                <li nz-menu-item (click)="onReleaseLockerClick()">
                  Ausgewählte Schlüssel zurücknehmen
                </li>
              </ul>
            </nz-dropdown-menu>
          </div>
        </ng-container>
        <ng-template #changeClothing>
          <app-main-button
            [disabled]="!!provisionRequest.beendetAm"
            (click)="closeClothingRequest()"
          >
            Kleiderausgabe beenden
          </app-main-button>
        </ng-template>
      </div>

      <ng-container *ngIf="requestPersons$ | async">
        <nz-table
          #table
          [nzFrontPagination]="false"
          [nzShowPagination]="false"
          [nzScroll]="{ y: '350px' }"
          [nzData]="persons"
        >
          <thead>
            <tr>
              <th
                *ngIf="!provisionRequest.bezeichnung.includes('Kleidertausch')"
                nzWidth="50px"
                [nzChecked]="checked"
                [nzIndeterminate]="indeterminate"
                nzLabel="Select all"
                (nzCheckedChange)="onAllChecked($event)"
              ></th>
              <th>Name</th>
              <th
                nzCustomFilter
                [nzSortFn]="
                  provisionRequest.kleidungsart === '2'
                    ? listOfSortFilterOptions.sortByLabCoatSize
                    : null
                "
                [nzShowSort]="provisionRequest.kleidungsart === '2'"
                [nzSortOrder]="
                  provisionRequest.kleidungsart === '2' ? 'asc' : null
                "
              >
                Kleidergröße
              </th>
              <th
                *ngIf="!provisionRequest.bezeichnung.includes('Kleidertausch')"
              >
                Spind
              </th>
              <th
                *ngIf="!provisionRequest.bezeichnung.includes('Kleidertausch')"
              >
                Aktion
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let person of table.data">
              <td
                *ngIf="!provisionRequest.bezeichnung.includes('Kleidertausch')"
                [nzChecked]="setOfCheckedId.has(person.id)"
                (nzCheckedChange)="onItemChecked(person.id, $event)"
              ></td>
              <td nz-tooltip [nzTooltipTitle]="tooltipPerson">
                {{ person.vorname + ' ' + person.name }}
              </td>
              <ng-template #tooltipPerson>
                <span><b>Geschlecht:</b> {{ person.geschlecht }}</span
                ><br />
                <span><strong>Firma:</strong> {{ person.firma }}</span
                ><br />
                <span><strong>KartenNr:</strong> P-{{ person.id }}</span>
              </ng-template>
              <td *ngIf="ausstattung; else noClothes">
                <div
                  class="flex items-center justify-between space-x-10 cursor-pointer pr-10"
                  (click)="showClothingModal(person)"
                >
                  <div class="flex flex-col">
                    <ng-container
                      *ngIf="
                        provisionRequest.kleidungsart === '2';
                        else otherClothingTypes
                      "
                    >
                      <!-- Kittel -->
                      <div class="flex items-center space-x-2">
                        <span>
                          <ng-container
                            *ngIf="person.groesseKittel; else noKittel"
                          >
                            Kittel: {{ getSizeText(person.groesseKittel) }}
                          </ng-container>
                          <ng-template #noKittel>Keine Kittelgröße</ng-template>
                        </span>
                        <span
                          *ngIf="person.kittelInventarnummer"
                          nz-icon
                          nzType="check-circle"
                          nzTheme="twotone"
                          nzTwotoneColor="#52c41a"
                          nz-tooltip="Kittel ausgeliehen"
                        ></span>
                      </div>
                    </ng-container>

                    <ng-template #otherClothingTypes>
                      <ng-container
                        *ngIf="
                          provisionRequest.kleidungsart === '1' ||
                          provisionRequest.kleidungsart === '3'
                        "
                      >
                        <!-- Hose -->
                        <div class="flex items-center space-x-2">
                          <span>
                            <ng-container
                              *ngIf="person.groesseHose; else noHose"
                            >
                              Hose: {{ getSizeText(person.groesseHose) }}
                            </ng-container>
                            <ng-template #noHose>Keine Hosengröße</ng-template>
                          </span>
                          <span
                            *ngIf="person.hoseInventarnummer"
                            nz-icon
                            nzType="check-circle"
                            nzTheme="twotone"
                            nzTwotoneColor="#52c41a"
                            nz-tooltip="Hose ausgeliehen"
                          ></span>
                        </div>

                        <!-- Jacke -->
                        <div class="flex items-center space-x-2">
                          <span>
                            <ng-container
                              *ngIf="person.groesseJacke; else noJacke"
                            >
                              Jacke: {{ getSizeText(person.groesseJacke) }}
                            </ng-container>
                            <ng-template #noJacke
                              >Keine Jackengröße</ng-template
                            >
                          </span>
                          <span
                            *ngIf="person.jackeInventarnummer"
                            nz-icon
                            nzType="check-circle"
                            nzTheme="twotone"
                            nzTwotoneColor="#52c41a"
                            nz-tooltip="Jacke ausgeliehen"
                          ></span>
                        </div>

                        <!-- Hemd -->
                        <div class="flex items-center space-x-2">
                          <span>
                            <ng-container
                              *ngIf="person.groesseHemd; else noHemd"
                            >
                              Hemd: {{ getSizeText(person.groesseHemd) }}
                            </ng-container>
                            <ng-template #noHemd>Keine Hemdgröße</ng-template>
                          </span>
                          <span
                            *ngIf="person.hemdInventarnummer"
                            nz-icon
                            nzType="check-circle"
                            nzTheme="twotone"
                            nzTwotoneColor="#52c41a"
                            nz-tooltip="Hemd ausgeliehen"
                          ></span>
                        </div>
                      </ng-container>
                    </ng-template>
                  </div>
                  <ng-container *ngIf="!provisionRequest.beendetAm">
                    <span
                      nz-tooltip
                      nzTooltipTitle="Kleidung scannen"
                      nz-icon
                      nzType="qrcode"
                      nzTheme="outline"
                    ></span>
                  </ng-container>
                </div>
              </td>
              <ng-template #noClothes>
                <td>Keine Ausstattung</td>
              </ng-template>
              <ng-template #noSizes>
                <td>Keine Größenangaben</td>
              </ng-template>
              <td
                *ngIf="!provisionRequest.bezeichnung.includes('Kleidertausch')"
              >
                <ng-container
                  *ngIf="
                    person.spindId && person.status === 'Zugewiesen';
                    else notAssigned
                  "
                >
                  {{ person.spindBezeichnung }}
                </ng-container>

                <ng-template #notAssigned>
                  <span
                    class="flex justify-between items-center w-full cursor-pointer"
                    [ngClass]="{
                      'readonly-select': provisionRequest.beendetAm
                    }"
                    (click)="showModal(person)"
                  >
                    <span
                      nz-tooltip
                      nzTooltipTitle="Vorgeschlagener Spind"
                      [ngClass]="{
                        'text-orange-400': !provisionRequest.beendetAm,
                        'font-bold': !provisionRequest.beendetAm
                      }"
                      >{{ person.spindBezeichnung ?? ' - ' }}*</span
                    >
                    <ng-container *ngIf="!provisionRequest.beendetAm">
                      <span
                        nz-tooltip
                        nzTooltipTitle="Spindvorschlag anpassen"
                        nz-icon
                        nzType="edit"
                        nzTheme="outline"
                      ></span>
                    </ng-container>
                  </span>
                </ng-template>
              </td>
              <td
                *ngIf="!provisionRequest.bezeichnung.includes('Kleidertausch')"
              >
                <ng-container
                  *ngIf="person.status !== 'Zugewiesen'; else assigned"
                >
                  <app-main-button
                    [ngClass]="{
                      'readonly-select': provisionRequest.beendetAm
                    }"
                    size="small"
                    shape="round"
                    [disabled]="!!provisionRequest.beendetAm"
                    (click)="acceptLocker(person, false)"
                  >
                    Spind ausgeben
                  </app-main-button>
                </ng-container>
                <ng-template #assigned>
                  <app-main-button
                    [ngClass]="{
                      'readonly-select': provisionRequest.beendetAm
                    }"
                    size="small"
                    shape="round"
                    (click)="releaseLocker(person, false)"
                  >
                    Schlüsselrücknahme
                  </app-main-button>
                </ng-template>
              </td>
              <ng-template #popoverPerson>
                <p>Geschlecht: {{ person.geschlecht }}</p>
                <p>Firma: {{ person.firma }}</p>
              </ng-template>
            </tr>
          </tbody>
        </nz-table>
      </ng-container>
    </ng-container>

    <ng-template #loading>
      <div class="grid grid-cols-1 space-y-4">
        <p class="flex justify-center">Lade Spindinformationen...</p>
        <nz-spin class="flex justify-center" nzSimple></nz-spin>
      </div>
    </ng-template>
  </div>

  <nz-modal
    [nzFooter]="modalFooter"
    [(nzVisible)]="modalIsVisible"
    nzTitle="Spindzuweisung"
    (nzOnCancel)="handleCancel()"
    (nzOnOk)="handleOk()"
  >
    <ng-container *nzModalContent>
      <div class="grid grid-cols-12 items-center">
        <p class="font-bold col-span-5">Vorgeschlagener Spind:</p>
        <nz-select
          [(ngModel)]="selectedLocker"
          nzSize="default"
          class="col-span-7"
        >
          <nz-option-group nzLabel="B835">
            <ng-container *ngFor="let locker of lockerSuggestions$ | async">
              <nz-option
                *ngIf="locker.standort === 'B835'"
                [nzValue]="locker"
                [nzLabel]="locker.bezeichnung"
              ></nz-option>
            </ng-container>
          </nz-option-group>
          <nz-option-group nzLabel="B836">
            <ng-container *ngFor="let locker of lockerSuggestions$ | async">
              <nz-option
                *ngIf="locker.standort === 'B836'"
                [nzValue]="locker"
                [nzLabel]="locker.bezeichnung"
              ></nz-option>
            </ng-container>
          </nz-option-group>
          <nz-option-group nzLabel="B845">
            <ng-container *ngFor="let locker of lockerSuggestions$ | async">
              <nz-option
                *ngIf="locker.standort === 'B845'"
                [nzValue]="locker"
                [nzLabel]="locker.bezeichnung"
              ></nz-option>
            </ng-container>
          </nz-option-group>
          <nz-option-group nzLabel="Gebäude unbekannt">
            <ng-container *ngFor="let locker of lockerSuggestions$ | async">
              <nz-option
                *ngIf="locker.standort === 'Gebäude unbekannt'"
                [nzValue]="locker"
                [nzLabel]="locker.bezeichnung"
              ></nz-option>
            </ng-container>
          </nz-option-group>
        </nz-select>
      </div>
      <nz-descriptions [nzColumn]="1">
        <nz-descriptions-item nzTitle="Bemerkung">
          {{ selectedLocker?.bemerkung }}
        </nz-descriptions-item>
      </nz-descriptions>
    </ng-container>
    <ng-template #modalFooter>
      <div class="flex justify-end">
        <app-main-button (click)="handleOk()" class="pr-2"
          >Spind vorschlagen
        </app-main-button>
        <app-main-button
          type="danger"
          (click)="handleCancel()"
          class="flex justify-end"
          >Abbrechen
        </app-main-button>
      </div>
    </ng-template>
  </nz-modal>
  <nz-modal
    [(nzVisible)]="clothingModalIsVisible"
    nzTitle="Manueller Kleiderscan"
    (nzOnCancel)="handleCancel()"
    [nzFooter]="null"
  >
    <ng-container *nzModalContent>
      <div class="flex flex-col items-center justify-center space-y-5 pb-2">
        <p class="text-2xl">Scanvorgang gestartet</p>
        <nz-spin nzSimple nzSize="large"></nz-spin>
      </div>
    </ng-container>
  </nz-modal>
</div>

<div id="print-section" class="hidden print:block">
  <div class="flex justify-between">
    <h2 class="text-xl font-bold pb-4">
      Teilnehmer:innen {{ provisionRequest?.modul?.bezeichnung }}
    </h2>
    <h3 class="text-lg font-bold pb-4">
      Ausbilder: {{ provisionRequest?.ersteller?.vorname }}
      {{ provisionRequest?.ersteller?.name }}
    </h3>
  </div>

  <nz-table
    #printableTable
    [nzData]="printPersons"
    [nzFrontPagination]="false"
    [nzShowPagination]="false"
    [nzSize]="'small'"
    [nzTotal]="30"
    class="w-full border border-collapse"
  >
    <thead>
      <tr>
        <th class="border px-4 py-2 text-left">Name</th>
        <th class="border px-4 py-2 text-left">Kittelinventarnummer</th>
        <th class="border px-4 py-2 text-left">Spindbezeichnung</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let person of printableTable.data">
        <td class="border px-4 py-2">{{ person.vorname }} {{ person.name }}</td>
        <td class="border px-4 py-2">
          {{ person.kittelInventarnummer }}
        </td>
        <td class="border px-4 py-2">
          {{ person.status === 'Zugewiesen' ? person.spindBezeichnung : '' }}
        </td>
      </tr>
    </tbody>
  </nz-table>
</div>
